import _unitOnlineUsage from './model';
import create from './create';

const UnitOnlineUsage = _unitOnlineUsage;

UnitOnlineUsage.create = create;

export default UnitOnlineUsage;



// WEBPACK FOOTER //
// ./data/OnlineUsage/UnitOnlineUsage/index.js